module.exports = __webpack_public_path__ + "static/media/item-view.d342f4a5.jpg";